export default {
  message: {
    title: 'Official Customer Service',
    dispute: {
      id: 'Dispute ID',
      createdAt: 'Initiation Time',
      orderDetails: 'Order Details',
      inArbitration: 'In Arbitration',
      serialNumber: 'Serial Number',
      orderNumber: 'Order Number',
      txnAmount: 'Total Amount',
      enableRefundAmount: 'Refundable Amount',
      holderEmail: 'Consumer Email',
      holderName: 'Consumer Name',
      txnTime: 'Order Date',
      txnWebsite: 'Transaction Website',
      productInfo: 'Products',
      endDispute: 'Close Dispute',
      applyArbitration: 'Apply For Arbitration',
      reset: 'Reset',
      send: 'Send',
      apply: 'Initiate Disputes',
      cardNoLast4: 'Last 4 Digits Of Card Number',
      type: 'Dispute Type',
      claims: 'Claims',
      claimsPlaceholder: 'Please enter the main reason for your dispute and the expected solution',
      nameHello: 'Dear {name}',
      orderInfo: 'You made a <span class="amount"> {currency} {amount} </span> purchase on <a href="{link}" target="_blank" class="website"> {website} </a> from <span class="date"> {date} </span>',
      tip: 'If you have any questions about this order, please enter and send dispute information',
      systemMessage: 'System messages',
      typeOptions: {
        unknow: 'Unknow',
        fraud: 'Fraud',
        unauthorized: 'Unauthorized',
        wrongGoods: 'Products Discrepancies',
        productNotReceived: 'Product Not Received',
        defectiveMerchandise: 'Defective Merchandise',
        incorrectTransaction: 'Incorrect Transaction',
        wrongAddress: 'Wrong address',
        creditNotProcessed: 'Credit Not Processed'
      },
      status: {
        0: 'In Coordination',
        1: 'In Arbitration',
        // 2: '已仲裁',去掉这个状态，不翻译
        3: 'Ended'
      },
      applyArbitrationSuccess: 'You have applied for arbitration',
      endDisputeSuccess: 'You have ended this dispute',
      comfirm: 'Submit',
      logisticsNumber: 'Tracking No'
    },
    checkout: {
      title: 'หน้าชำระเงินที่ปลอดภัย',
      description: 'เรารักษาข้อมูลทางการเงินของคุณอย่างปลอดภัยและเข้ารหัส',
      methodErrorTips: 'ขอโทษด้วยนะคะ ประเทศที่คุณเลือกไม่ได้รับการสนับสนุนในขณะนี้ กรุณาเลือกประเทศอื่นและลองใหม่อีกครั้ง.',
      recommendation: 'คำแนะนำ',
      cardNumber: 'หมายเลขบัตร',
      cardName: 'ชื่อบนบัตร',
      cvv: 'CVV',
      expiredDate: 'วันหมดอายุ',
      billingInfo: 'ข้อมูลการเรียกเก็บเงิน',
      country: 'ประเทศ',
      state: 'รัฐ',
      firstName: 'ชื่อจริง',
      lastName: 'นามสกุล',
      document: 'เอกสาร',
      city: 'เมือง',
      address: 'ที่อยู่',
      streetNumber: 'หมายเลขถนน',
      zipCode: 'รหัสไปรษณีย์',
      email: 'อีเมล',
      phone: 'หมายเลขโทรศัพท์',
      pay: 'จ่าย',
      choosePaymentMethod: 'เลือกวิธีการชำระเงิน',
      continue: 'ดำเนินการต่อ',
      later: 'ภายหลัง',
      returnToMerchant: 'ยกเลิกและกลับไปที่ร้านค้า',
      resultToMerchant: 'กลับไปที่ร้านค้า',
      orderId: 'รหัสคำสั่งซื้อ',
      orderAmount: 'ยอดคำสั่งซื้อ',
      billingDescriptor: 'รายละเอียดการเรียกเก็บเงิน',
      goodsName: 'ชื่อสินค้า',
      timeLimit: 'กรุณาทำการชำระเงินภายในเวลาที่กำหนด มิฉะนั้นหน้าจะหมดเวลา',
      otherPaymentMethods: 'วิธีการชำระเงินอื่น ๆ',
      close: 'ปิด',
      paymentErrorTitle: 'การชำระเงินล้มเหลว',
      paymentErrorTip: 'การชำระเงินของคุณไม่สำเร็จ โปรดลองอีกครั้ง',
      paymentFailed: 'กระบวนการชำระเงินล้มเหลว',
      continueShopping: 'ดำเนินการซื้อสินค้าต่อ',
      paymentSuccess: 'กระบวนการชำระเงินสำเร็จ',
      paymentPending: 'ส่งการชำระเงินแล้ว รอการยืนยัน',
      correctDateTip: 'กรุณากรอกวันที่หมดอายุที่ถูกต้อง',
      correctCardNumberTip: 'กรุณากรอกหมายเลขบัตรที่ถูกต้อง',
      correctSecurityCodeTip: 'กรุณากรอกรหัสความปลอดภัยที่ถูกต้อง',
      mobileMoneyOperator: 'ผู้ให้บริการเงินมือถือ',
      bank: 'ธนาคาร',
      correctEmailAddressTip: 'กรุณาป้อนอีเมลที่ถูกต้อง',
      notSupportPaymentTip: 'สภาพแวดล้อมปัจจุบันไม่รองรับการชำระเงินด้วย {type}',
      addValidPaymentCard: 'โปรดเพิ่มบัตรชำระเงินที่ถูกต้อง',
      timeLimitTip: 'จะมีการหักเงินก่อนเวลาทดลองใช้หมดอายุ 12 ชั่วโมง (<span class="date">{date}</span>) หลังจากนั้นจะมีการต่ออายุทุก <span class="date">{month}</span> เดือน จำนวน <span class="amount"> {amount} {currency}</span> สามารถยกเลิกได้ตลอดเวลา',
      product: 'สินค้า/บริการ',
      subscribeType: 'ประเภทการสมัครสมาชิก',
      renewCycle: 'รอบการต่ออายุ',
      renewAmount: 'จำนวนเงินต่ออายุ',
      subscribePay: 'สมัครสมาชิกและชำระเงิน',
      readAgreement: "อ่านและยอมรับ<span class='protocol-link' style='color: #31a7da;'>《ข้อตกลงการต่ออายุอัตโนมัติ》</span>",
      depict: 'คำอธิบาย',
      copyQrCode: 'คัดลอกรหัส QR',
      copySuccess: 'คัดคัดสำเร็จ',
      copyError: 'คัดคัดไม่สำเร็จ',
      refreshQrCode: 'อัปเดตรหัส QR'
    },
    subscribe: {
      yourSubscribe: 'การสมัครสมาชิกของคุณ',
      unsubscribeTip: 'หากต้องการยกเลิก คุณสามารถคลิกปุ่ม [ยกเลิกการสมัคร] ที่ด้านล่างของหน้า',
      renewTip: 'หักเงิน <span class="amount"> {amount} {currency}</span> ในวันที่ <span class="date">{date}</span> สามารถยกเลิกได้ตลอดเวลา',
      unsubscribe: 'ยกเลิกการสมัคร',
      autoRenew: 'ข้อตกลงการต่ออายุอัตโนมัติ',
      unsubscribeTipTwo: 'หากยกเลิกตอนนี้ คุณยังสามารถใช้งานการสมัครสมาชิกนี้ได้จนถึง<span class="date">{date}</span>',
      emailVerifyTip: 'ยืนยันอีเมล',
      inputCodeTip: 'กรุณากรอกรหัสยืนยัน',
      sendSuccessTip: 'ส่งรหัสยืนยันสำเร็จ',
      sendErrorTip: 'ส่งรหัสยืนยันล้มเหลว',
      unsubscribeSuccessTip: 'ยกเลิกการสมัครสำเร็จ',
      unsubscribeErrorTip: 'ยกเลิกการสมัครล้มเหลว',
      sendCodeTip: 'ส่งอีกครั้งในอีก {code} วินาที',
      sendEmailTip: 'รับรหัสยืนยัน',
      daily: 'ทุก วัน',
      weekly: 'ทุก 7 วัน',
      monthly: 'ทุก 30 วัน',
      quarterly: 'ทุก 90 วัน',
      semiAnnually: 'ทุก 180 วัน',
      annually: 'ทุก 365 วัน',
      regularRenewal: 'การต่ออายุอัตโนมัติ',
      oneTime: 'ครั้งเดียว',
      inputNumberTip: 'กรุณากรอกตัวเลขเท่านั้น',
      eachCalendarMonth: 'ทุกเดือนปฏิทิน'
    },
    common: {
      confirm: 'ยืนยัน',
      cancel: 'ยกเลิก',
      uploadImgErrorTip: 'สามารถอัปโหลดภาพเท่านั้น',
      inputMessageTip: 'กรุณากรอกเนื้อหา',
      sendSuccessTip: 'การส่งสำเร็จ',
      sendErrorTip: 'การส่งล้มเหลว',
      inputPlaceholder: 'กรุณาใส่ {field}',
      selectPlaceholder: 'กรุณาเลือก {field}',
      correctFormat: 'โปรดป้อนรูปแบบที่ถูกต้อง ตัวอย่างเช่น: {example}'
    }
  }
}
